<template>
  <v-container>
    <div class="center-text">
      <h3>Please sign up to download or buy</h3>
    </div>
    <br>
    <v-row v-if="error">
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <app-alert
          :text="error.message"
          @dismissed="onDismissed"
        ></app-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignup">
                <validation-observer
                  ref="observer"
                  v-slot="{ invalid }"
                >
                  <v-row class="d-flex justify-center">
                    <v-col
                      class="pb-0"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Email"
                        rules="required|email"
                      >
                        <v-text-field
                          id="email"
                          v-model="email"
                          name="email"
                          label="Email"
                          type="email"
                          required
                          outlined
                          prepend-inner-icon="mdi-email-outline"
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <v-col
                      class="pb-0"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        vid="password"
                        name="Password"
                        rules="required"
                      >
                        <v-text-field
                          id="password"
                          v-model="password"
                          name="password"
                          label="Password"
                          required
                          outlined
                          :type="show ?'text':
                            'password'"
                          :append-icon="show ?'mdi-eye-outline':'mdi-eye-off'"
                          prepend-inner-icon="mdi-lock"
                          :error-messages="errors"
                          @click:append="show=!show"
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <v-col>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Confirm Password"
                        rules="required|confirmed:password"
                      >
                        <v-text-field
                          id="confirmPassword"
                          v-model="confirmPassword"
                          name="confirmPassword"
                          label="Confirm Password"
                          :type="show ?'text':
                            'password'"
                          :append-icon="show ?'mdi-eye-outline':'mdi-eye-off'"
                          prepend-inner-icon="mdi-lock"
                          :error-messages="errors"
                          outlined
                          @click:append="show=!show"
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <v-col>
                      <v-checkbox
                        id="gdpr-consent"
                        v-model="consent"
                        :rules="[v => !!v || 'You must agree to the Privacy Policy to continue.']"
                        label="I have read and agree to the Privacy Policy"
                      ></v-checkbox>
                      <router-link to="/privacy-policy">
                        Privacy Policy
                      </router-link>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <v-col
                      cols="12"
                      class="d-flex justify-center pt-0"
                    >
                      <v-btn
                        class="primary whtie--text mr-0 login-btn-new cta-button download-button"
                        block
                        large
                        style="text-transform: none;"
                        type="submit"
                        :disabled="invalid || !consent"
                      >
                        Sign Up
                      </v-btn>
                    </v-col>
                  </v-row>
                </validation-observer>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        email: '',
        password: '',
        confirmPassword: '',
        show: false,
        consent: false, // for GDPR consent checkbox
      }
    },
    computed: {
      comparePasswords () {
        return this.password !== this.confirmPassword ? 'Passwords do not match' : ''
      },
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      onSignup () {
        this.$store.dispatch('signUserUp', { email: this.email, password: this.password })
        // trackEvent({
        //   event: 'Sign Up Button Hit',
        //   event_category: 'Button Clicks',
        //   event_action: 'Click',
        //   event_label: 'User Signed Up'
        // })
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      }
    }
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .center-text {
  text-align: center;
  color: #4CAF50;
}
</style>
